import { responseTypes } from "utils/Types";

export type Method = "GET" | "POST" | "PATCH" | "DELETE" | "PUT" | "UPLOAD";

export const HTTP_METHOD: Record<Method, Method> = {
  GET: "GET",
  POST: "POST",
  PATCH: "PATCH",
  DELETE: "DELETE",
  PUT: "PUT",
  UPLOAD: "UPLOAD"
};

export const QUERY_PARAM = {
  SIZE: "size",
  PAGE: "page",
  SORT: "sort",
  PAGENO: "pageNo",
  HLTIDS: "hltIds"
};

export const handleResponse = (response: any, thunkApi: any) => {
  if (response.status < responseTypes.success_threshold) {
    return { status: response.status, ...response.data };
  }
  return thunkApi.rejectWithValue(response);
};

export const buildQueryString = (params: any) => {
  const query = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    query.append(key, value);
  }); // Add each parameter if it exists and is not an empty string
  return query.toString();
};
